import env from '@y2/environments';

import { getWithSSRSupport } from '../helpers';
import axios, { ResponseBody } from '../http-client';

type ResponseSchema = {
  message: string;
  data?: object;
};

type ProjectType = 'sales' | 'rent' | 'commercial';
type Source = 'map' | 'internal' | 'tankYou';

export type Yad1LeadPayload = {
  name: string;
  projectId: string | number;
  phone: string;
  trackingId: string;
  listingId?: string;
  email: string;
  site: string;
  projectType: ProjectType;
  source: Source;
};
export type GreyLeadBody = {
  name: string;
  projectId: string;
  phone: string;
  email: string;
};

const serviceName = 'yad1-lead';

/**
 * client for `yad1-lead` service
 * @see https://gw.yad2.io/yad1-lead/api-docs/#
 */
export const yad1LeadClient = (baseUrl = env.routes.api.gw) => {
  const client = axios.create({
    baseURL: getWithSSRSupport(baseUrl, serviceName),
    withCredentials: true,
  });

  return {
    postListingYad1Lead: (leadData: Yad1LeadPayload) =>
      client.post<ResponseBody<ResponseSchema>>('/listing', leadData),
    postProjectYad1Lead: (leadData: Yad1LeadPayload) =>
      client.post<ResponseBody<ResponseSchema>>('/project', leadData),
    postGreyProjectLead: (leadData: GreyLeadBody) =>
      client.post<ResponseBody<ResponseSchema>>('/greyLead', leadData),
  };
};
